import { Reducer } from '../redux';

import { ISetLastActivityAction, SessionActionType } from './session-actions';
import { ISessionState } from './state';

type SessionActions = ISetLastActivityAction;

export const sessionInitialState: ISessionState = {
    lastActivity: new Date()
};

export const sessionReducer: Reducer<ISessionState, SessionActions> = (
    state = sessionInitialState,
    action
) => {
    switch (action.type) {
        case SessionActionType.SET_LAST_ACTIVITY: {
            console.log(`Session: set [${action.lastActivity}]`);
            return {
                lastActivity: action.lastActivity
            };
        }

        default: {
            return state;
        }
    }
};
